/* Good Travel · Pide tu presupuesto */
(function () {
'use strict';
var root = document.getElementById('gtq');
if (!root || root.dataset.ready) return;
root.dataset.ready = '1';
var KEY = 'gtq-ultima-solicitud';
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
function $(s, el) { return (el || root).querySelector(s); }
function $$(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
function store(get, val) {
try { if (get) return JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.setItem(KEY, JSON.stringify(val)); } catch (e) { return null; }
}
function scroller() {
var w = document.querySelector('.page-wrapper');
return window.matchMedia('(min-width: 990px)').matches && w && w.scrollHeight > w.clientHeight ? w : null;
}
function toTop() {
var w = scroller();
var h = document.getElementById('gth');
var y = root.getBoundingClientRect().top - (h ? h.offsetHeight : 0);
if (Math.abs(y) < 4) return;
(w || window).scrollBy({ top: y, behavior: reduce ? 'auto' : 'smooth' });
}
function shortDate(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + MESES[d.getMonth()]; }
function isoDate(d) { return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear(); }
function euros(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €'; }
function plural(n, s, p) { return n + ' ' + (n === 1 ? s : p); }
/* ---------- Página de éxito ---------- */
var done = $('[data-done]');
if (done) {
var last = store(true);
if (last) {
$('[data-ticket]').hidden = false;
$('[data-t-code]').textContent = last.code || 'GT';
$('[data-t-dest]').textContent = last.dest || '—';
$('[data-t-dates]').textContent = last.dates || 'Por concretar';
$('[data-t-pax]').textContent = last.pax || '—';
$('[data-t-ref]').textContent = last.ref || 'GT';
if (last.nombre) $('[data-done-title]').textContent = '¡Gracias, ' + last.nombre + '! Tu viaje ya está en marcha';
var wa = $('[data-wa-link]');
if (wa) {
var msg = 'Hola, soy ' + (last.nombre || '') + '. Acabo de pedir un presupuesto en la web (ref. ' + last.ref + ') para ' + (last.dest || 'un viaje') + '.';
wa.href = wa.href.split('?')[0] + '?text=' + encodeURIComponent(msg);
}
}
if (!reduce) {
var c = $('[data-confetti]'), colors = ['#F5B700', '#0D014B', '#FFE08A', '#2A2190', '#9CC9FF'];
for (var i = 0; i < 46; i++) {
var p = document.createElement('i');
p.style.left = Math.random() * 100 + '%';
p.style.background = colors[i % colors.length];
p.style.animationDelay = (Math.random() * 0.9) + 's';
p.style.animationDuration = (2.4 + Math.random() * 1.8) + 's';
p.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
c.appendChild(p);
}
}
setTimeout(toTop, 60);
return;
}
var form = $('form');
if (!form) return;
/* ---------- Estado ---------- */
var S = { step: 1, dest: null, ap: null, apText: '', start: null, end: null, flex: false, who: null, adultos: 2, ninos: 0, bebes: 0, budget: 1500, budgetTouched: false, paxTouched: false,
hotel: false, noches: 1, hab: 1, nochesTouched: false };
var ref = 'GT-' + Date.now().toString(36).slice(-3).toUpperCase() + Math.random().toString(36).slice(2, 4).toUpperCase();
function F(k) { return $('[data-f="' + k + '"]'); }
F('ref').value = ref;
$('[data-ref-view]').textContent = ref;
var nextBtn = $('[data-next]'), submitBtn = $('[data-submit]'), backBtn = $('[data-back]');
/* ---------- Resumen ---------- */
function datesText() {
if (S.start && S.end) return shortDate(S.start) + ' – ' + shortDate(S.end);
if (S.start) return 'Desde el ' + shortDate(S.start);
if (S.flex) return 'Fechas flexibles';
return '';
}
function paxText() {
var t = plural(S.adultos, 'adulto', 'adultos');
if (S.ninos) t += ' · ' + plural(S.ninos, 'niño', 'niños');
if (S.bebes) t += ' · ' + plural(S.bebes, 'bebé', 'bebés');
return t;
}
function hotelText() { return plural(S.noches, 'noche', 'noches') + ' · ' + plural(S.hab, 'habitación', 'habitaciones'); }
function budgetText() { return S.budget >= 8000 ? '8.000 € o más' : euros(S.budget); }
function nights() { return S.start && S.end ? Math.round((S.end - S.start) / 864e5) : 0; }
function summary() {
var d = datesText();
$('[data-sum-dest]').textContent = S.dest ? S.dest.name : 'Tu próximo destino';
var box = $('[data-sum-img]'), img = box.querySelector('img');
if (S.dest && S.dest.img) {
if (!img) { img = document.createElement('img'); img.alt = ''; box.insertBefore(img, box.firstChild); }
if (img.getAttribute('src') !== S.dest.img) img.src = S.dest.img;
} else if (img) { img.remove(); }
var sd = $('[data-sum-dates]'); sd.textContent = d || 'Por elegir'; sd.classList.toggle('q-empty', !d);
$('[data-sum-pax]').textContent = paxText();
$$('[data-sum-hotel-row]').forEach(function (el) { el.hidden = !S.hotel; });
$('[data-sum-hotel]').textContent = S.hotel ? hotelText() : '—';
var sb = $('[data-sum-budget]'); sb.textContent = S.budgetTouched ? budgetText() : 'Por definir'; sb.classList.toggle('q-empty', !S.budgetTouched);
var hasAps = !!(S.dest && S.dest.aps && S.dest.aps.length);
$$('[data-sum-ap-row]').forEach(function (el) { el.hidden = !hasAps; });
var sa = $('[data-sum-ap]'); sa.textContent = S.ap ? S.ap : (S.ap === '' ? 'Sin preferencia' : 'Por elegir'); sa.classList.toggle('q-empty', S.ap === null);
$('[data-stub-code]').textContent = S.dest ? (S.ap || S.dest.code) : '—';
$('[data-stub-dates]').textContent = d || 'Por concretar';
$('[data-stub-pax]').textContent = paxText();
var info = $('[data-foot-info]');
if (S.dest) {
info.innerHTML = '';
var b = document.createElement('b'); b.textContent = S.dest.name; info.appendChild(b);
info.appendChild(document.createTextNode([d, plural(S.adultos + S.ninos + S.bebes, 'viajero', 'viajeros')].filter(Boolean).map(function (x) { return ' · ' + x; }).join('')));
} else { info.textContent = 'Elige un destino para empezar'; }
refresh();
}
/* ---------- Validación ---------- */
function fieldOk(el) {
if (el.type === 'checkbox') return el.checked;
var v = String(el.value).trim();
if (!v) return false;
if (el.type === 'email') return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
if (el.type === 'tel') return v.replace(/\D/g, '').length >= 6;
return true;
}
function valid(n) {
if (n === 1) return !!S.dest;
if (n === 2) return !!(S.start || S.flex) && !!S.who;
return $$('[data-panel="3"] [data-req]').every(fieldOk);
}
function refresh() {
nextBtn.setAttribute('aria-disabled', String(!valid(S.step)));
submitBtn.setAttribute('aria-disabled', String(!valid(3)));
}
function shake(el) { if (!el || reduce) return; el.classList.remove('q-shake'); void el.offsetWidth; el.classList.add('q-shake'); }
function complain(n) {
var info = $('[data-foot-info]');
if (n === 1) { shake($('[data-tiles]')); return; }
if (n === 2) {
if (!(S.start || S.flex)) { shake($('[data-need="dates"]')); info.textContent = 'Elige tus fechas o marca que son flexibles'; return; }
if (!S.who) { shake($('[data-need="who"]')); info.textContent = 'Dinos con quién viajas'; }
return;
}
$$('[data-panel="3"] [data-req]').forEach(function (el) {
var wrap = el.closest('.q-fl, .q-cb');
if (wrap) wrap.classList.toggle('q-bad', !fieldOk(el));
});
var firstBad = $$('[data-panel="3"] [data-req]').filter(function (el) { return !fieldOk(el); })[0];
if (firstBad) firstBad.focus();
}
/* ---------- Pasos ---------- */
function go(n, quiet) {
if (n > 1 && !S.dest) n = 1;
S.step = n;
$$('[data-panel]').forEach(function (p) { p.hidden = +p.dataset.panel !== n; });
$$('[data-side]').forEach(function (p) { p.hidden = +p.dataset.side !== n; });
$('.q-route').style.setProperty('--prog', (n - 1) / 2);
$$('[data-dot]').forEach(function (li) {
var i = +li.dataset.dot;
li.dataset.state = i < n ? 'done' : (i === n ? 'current' : '');
li.querySelector('.q-dot').textContent = i < n ? '✓' : i;
var b = li.querySelector('button');
if (i === n) b.setAttribute('aria-current', 'step'); else b.removeAttribute('aria-current');
});
nextBtn.hidden = n === 3 || (n === 1 && !S.dest);
$('.q-foot').hidden = n === 1 && !S.dest;
submitBtn.hidden = n !== 3;
backBtn.hidden = n === 1;
if (n === 2) cal.render();
summary();
if (!quiet) {
toTop();
var first = $('[data-panel="' + n + '"]').querySelector(n === 3 ? 'input:not([type=hidden])' : 'button, input');
if (first && n !== 1) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
}
}
nextBtn.addEventListener('click', function () { if (valid(S.step)) go(S.step + 1); else complain(S.step); });
backBtn.addEventListener('click', function () { go(S.step - 1); });
$$('[data-goto]').forEach(function (b) { b.addEventListener('click', function () { var n = +b.dataset.goto; if (n < S.step) go(n); }); });
/* ---------- Paso 1: destinos ---------- */
var tiles = $$('[data-pick]');
function pick(btn, name, code, img, quiet) {
tiles.forEach(function (t) { t.setAttribute('aria-pressed', String(t === btn)); });
var kn = known(name);
S.dest = { name: name, code: (code || name.slice(0, 3)).toUpperCase(), img: img || '', aps: (kn && kn.a) || [] };
F('dest').value = name;
S.ap = null; S.apText = ''; F('ap').value = '';
renderAps();
summary();
if (quiet) { go(2, true); return; }
setTimeout(function () { go(2); }, reduce ? 0 : 320);
}
tiles.forEach(function (b) { b.addEventListener('click', function () { pick(b, b.dataset.pick, b.dataset.code, b.dataset.img); }); });
var q = $('[data-q]'), other = $('[data-other]');
q.addEventListener('input', function () {
var term = q.value.trim().toLowerCase(), exact = false;
$$('[data-tiles] > li[data-name]').forEach(function (li) {
var show = !term || li.dataset.name.indexOf(term) > -1;
li.hidden = !show;
if (li.dataset.name === term) exact = true;
});
other.hidden = !term || exact;
$('[data-other-text]').textContent = q.value.trim();
});
q.addEventListener('keydown', function (e) {
if (e.key !== 'Enter') return;
e.preventDefault();
var visible = $$('[data-tiles] > li[data-name]:not([hidden]) [data-pick]');
if (visible.length === 1) visible[0].click();
else if (q.value.trim()) $('[data-pick-other]').click();
});
var DEST = {};
try { var dj = document.getElementById('gtq-dest-data'); if (dj) DEST = JSON.parse(dj.textContent) || {}; } catch (e) { DEST = {}; }
function known(name) { return DEST[String(name || '').trim().toLowerCase()] || null; }
function pickName(name, quiet) {
var k = known(name);
if (k) pick(null, k.n, k.c || k.n.slice(0, 3), k.img, quiet);
else pick(null, name, name.slice(0, 3), '', quiet);
}
/* Aeropuertos del destino */
var apBox = $('[data-aps]'), apBlock = $('[data-need="ap"]');
function setAp(a) {
S.ap = a[0] || '';
S.apText = S.ap ? S.ap + ' · ' + (a[1] || '') + (a[2] ? ' (' + a[2] + ')' : '') : 'Sin preferencia, que me aconsejen';
F('ap').value = S.apText;
summary();
}
function renderAps() {
var list = (S.dest && S.dest.aps) || [];
apBlock.hidden = !list.length;
apBox.innerHTML = '';
if (!list.length) return;
$('[data-ap-dest]').textContent = S.dest.name;
list.concat([['', 'Aún no lo sé', 'Que me aconsejéis']]).forEach(function (a, i) {
var w = document.createElement('div');
w.className = 'q-ap' + (a[0] ? '' : ' q-ap-any');
w.innerHTML = '<input type="radio" name="gtq-ap" id="gtq-ap-' + i + '"><label for="gtq-ap-' + i + '"><b></b><span></span><small></small></label>';
var inp = w.querySelector('input');
inp.value = a[0] || '';
w.querySelector('b').textContent = a[0] || '¿?';
w.querySelector('span').textContent = a[1] || '';
w.querySelector('small').textContent = a[2] || '';
if (S.ap !== null && S.ap === (a[0] || '')) inp.checked = true;
inp.addEventListener('change', function () { setAp(a); });
apBox.appendChild(w);
});
}
$('[data-pick-other]').addEventListener('click', function () { var v = q.value.trim(); if (v) pickName(v); });
/* ---------- Paso 2: calendario de rango ---------- */
var today = new Date(); today.setHours(0, 0, 0, 0);
var cal = {
y: today.getFullYear(), m: today.getMonth(), hover: null,
box: $('[data-cal-months]'),
count: function () { return window.matchMedia('(min-width: 750px)').matches ? 2 : 1; },
render: function (focusT) {
var n = this.count(), html = '';
this.box.style.setProperty('--months', n);
for (var k = 0; k < n; k++) {
var first = new Date(this.y, this.m + k, 1);
var title = first.toLocaleDateString('es-ES', { month: 'long', year: 'numeric' }); title = title.charAt(0).toUpperCase() + title.slice(1);
var offset = (first.getDay() + 6) % 7;
var days = new Date(first.getFullYear(), first.getMonth() + 1, 0).getDate();
html += '<div class="q-month"><h4>' + title + '</h4><div class="q-wk" aria-hidden="true"><span>L</span><span>M</span><span>X</span><span>J</span><span>V</span><span>S</span><span>D</span></div><div class="q-days" role="grid">';
for (var e = 0; e < offset; e++) html += '<span></span>';
for (var d = 1; d <= days; d++) {
var dt = new Date(first.getFullYear(), first.getMonth(), d), t = dt.getTime();
var past = dt < today;
html += '<button type="button" class="q-day" data-t="' + t + '"' + (past ? ' disabled' : '') + ' aria-label="' + dt.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }) + '"><span>' + d + '</span></button>';
}
html += '</div></div>';
}
this.box.innerHTML = html;
$('[data-cal-prev]').disabled = (this.y === today.getFullYear() && this.m <= today.getMonth());
this.mark();
if (focusT) { var f = this.box.querySelector('[data-t="' + focusT + '"]'); if (f) f.focus(); }
},
shift: function (delta, focusT) {
var d = new Date(this.y, this.m + delta, 1);
if (d < new Date(today.getFullYear(), today.getMonth(), 1)) return;
this.y = d.getFullYear(); this.m = d.getMonth(); this.render(focusT);
},
mark: function () {
var s = S.start && S.start.getTime(), e = S.end && S.end.getTime(), h = this.hover, tt = today.getTime();
$$('.q-day', this.box).forEach(function (b) {
var t = +b.dataset.t;
b.classList.toggle('is-today', t === tt);
b.classList.toggle('is-start', t === s);
b.classList.toggle('is-end', t === e || (!e && h && t === h));
b.classList.toggle('in-range', !!(s && e && t > s && t < e));
b.classList.toggle('in-hover', !!(s && !e && h && t > s && t < h));
b.setAttribute('aria-pressed', String(t === s || t === e));
});
},
choose: function (t) {
var d = new Date(t);
if (!S.start || S.end || d < S.start) { S.start = d; S.end = null; }
else if (d.getTime() === S.start.getTime()) { S.end = null; }
else { S.end = d; }
this.hover = null;
this.out();
},
out: function () {
$('[data-out-ida]').textContent = S.start ? shortDate(S.start) : '— —';
$('[data-out-vuelta]').textContent = S.end ? shortDate(S.end) : '— —';
var n = nights();
$('[data-out-nights]').textContent = n ? '☾ ' + plural(n, 'noche', 'noches') : '';
F('ida').value = S.start ? isoDate(S.start) : '';
F('vuelta').value = S.end ? isoDate(S.end) : '';
F('noches').value = n || '';
this.mark();
hotelSync();
summary();
}
};
cal.box.addEventListener('click', function (e) { var b = e.target.closest('.q-day'); if (b && !b.disabled) cal.choose(+b.dataset.t); });
cal.box.addEventListener('mouseover', function (e) {
var b = e.target.closest('.q-day');
if (!b || b.disabled || !S.start || S.end) return;
var t = +b.dataset.t;
if (t !== cal.hover) { cal.hover = t > S.start.getTime() ? t : null; cal.mark(); }
});
cal.box.addEventListener('mouseleave', function () { if (cal.hover) { cal.hover = null; cal.mark(); } });
cal.box.addEventListener('keydown', function (e) {
var b = e.target.closest('.q-day'); if (!b) return;
var step = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
if (!step) return;
e.preventDefault();
var d = new Date(+b.dataset.t); d.setDate(d.getDate() + step);
if (d < today) return;
var t = d.getTime(), target = cal.box.querySelector('[data-t="' + t + '"]');
if (target) target.focus();
else cal.shift(step > 0 ? 1 : -1, t);
});
$('[data-cal-prev]').addEventListener('click', function () { cal.shift(-1); });
$('[data-cal-next]').addEventListener('click', function () { cal.shift(1); });
var mq = window.matchMedia('(min-width: 750px)');
(mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () { if (S.step === 2) cal.render(); });
$('[data-flex]').addEventListener('change', function (e) { S.flex = e.target.checked; summary(); });
/* ---------- Hospedaje (opcional) ---------- */
var hotelBox = $('[data-hotel]');
function hcount(key, val) {
var box = $('[data-hcount="' + key + '"]');
if (!box) return;
var min = +box.dataset.min, max = +box.dataset.max;
val = Math.max(min, Math.min(max, val));
S[key] = val;
box.querySelector('output').textContent = val;
box.querySelector('[data-dec]').disabled = val <= min;
box.querySelector('[data-inc]').disabled = val >= max;
F(key === 'noches' ? 'h-noches' : 'h-hab').value = val;
}
function hotelSync() {
if (!hotelBox) return;
var n = nights();
if (n && !S.nochesTouched) hcount('noches', n);
var hint = $('[data-hotel-hint]');
if (hint) hint.textContent = n ? (S.noches === n ? 'Según tus fechas' : 'Tus fechas: ' + plural(n, 'noche', 'noches')) : 'Indica cuántas noches';
}
if (hotelBox) {
var hotelOn = $('[data-hotel-on]'), hotelBody = $('[data-hotel-body]');
hotelOn.addEventListener('click', function (e) {
e.preventDefault(); e.stopPropagation();
S.hotel = !S.hotel;
hotelOn.setAttribute('aria-checked', S.hotel ? 'true' : 'false');
hotelBody.hidden = !S.hotel;
$$('input, textarea', hotelBox).forEach(function (el) { el.disabled = !S.hotel; });
hotelSync();
summary();
});
$$('[data-hcount]', hotelBox).forEach(function (box) {
var key = box.dataset.hcount;
box.querySelector('[data-dec]').addEventListener('click', function () { if (key === 'noches') S.nochesTouched = true; hcount(key, S[key] - 1); hotelSync(); summary(); });
box.querySelector('[data-inc]').addEventListener('click', function () { if (key === 'noches') S.nochesTouched = true; hcount(key, S[key] + 1); hotelSync(); summary(); });
hcount(key, S[key]);
});
}
/* Con quién */
$$('input[name="contact[Con quién viaja]"]').forEach(function (r) {
r.addEventListener('change', function () {
S.who = r.value;
if (!S.paxTouched) {
var p = r.dataset.pax.split(',');
setCount('adultos', +p[0]); setCount('ninos', +p[1]);
}
summary();
});
});
/* Contadores: adultos, niños y bebés (máximo un bebé por adulto) */
function setCount(key, val) {
var box = $('[data-counter="' + key + '"]');
if (!box) return;
var min = +box.dataset.min, max = +box.dataset.max;
if (key === 'bebes') max = Math.min(max, S.adultos);
val = Math.max(min, Math.min(max, val));
S[key] = val;
box.querySelector('output').textContent = val;
box.querySelector('[data-dec]').disabled = val <= min;
box.querySelector('[data-inc]').disabled = val >= max;
F(key).value = val;
if (key === 'adultos' && $('[data-counter="bebes"]')) setCount('bebes', S.bebes);
}
$$('[data-counter]').forEach(function (box) {
var key = box.dataset.counter;
box.querySelector('[data-dec]').addEventListener('click', function () { S.paxTouched = true; setCount(key, S[key] - 1); summary(); });
box.querySelector('[data-inc]').addEventListener('click', function () { S.paxTouched = true; setCount(key, S[key] + 1); summary(); });
setCount(key, S[key]);
});
/* Presupuesto */
var range = $('[data-budget]');
function budget() {
S.budget = +range.value;
var p = (S.budget - range.min) / (range.max - range.min) * 100;
range.style.setProperty('--p', p + '%');
$('[data-out-budget]').textContent = budgetText();
range.setAttribute('aria-valuetext', budgetText());
F('budget').value = S.budgetTouched ? budgetText() : '';
}
range.addEventListener('input', function () { S.budgetTouched = true; budget(); summary(); });
budget();
/* Paso 3 */
$$('[data-panel="3"] [data-req]').forEach(function (el) {
el.addEventListener('input', function () { var w = el.closest('.q-fl, .q-cb'); if (w && fieldOk(el)) w.classList.remove('q-bad'); refresh(); });
el.addEventListener('change', refresh);
});
function onSend(e) {
if (!valid(3)) { e.preventDefault(); complain(3); return; }
if (!valid(1) || !valid(2)) { e.preventDefault(); go(!valid(1) ? 1 : 2); return; }
var nombre = $('#gtq-nom').value.trim();
F('name').value = (nombre + ' ' + $('#gtq-ape').value.trim()).trim();
var tel = $('#gtq-tel');
if (tel.value.trim().charAt(0) !== '+') tel.value = $('#gtq-pre').value.replace(' (RD)', '') + ' ' + tel.value.trim();
budget();
if (S.hotel) { F('h-noches').value = S.noches; F('h-hab').value = S.hab; }
submitBtn.classList.add('is-sending');
submitBtn.setAttribute('aria-busy', 'true');
if (S.dest.aps && S.dest.aps.length && S.ap === null) F('ap').value = 'Sin elegir';
store(false, { ref: ref, dest: S.dest.name, code: S.ap || S.dest.code, dates: datesText() || 'Por concretar', pax: paxText(), nombre: nombre });
}
/* Al pulsar «Enviar» (y con Enter) se completa todo antes de la verificación antirobots de Shopify */
submitBtn.addEventListener('click', onSend);
form.addEventListener('submit', onSend);
/* ---------- Inicio ---------- */
var pre = new URLSearchParams(location.search).get('destino');
if (pre) {
var match = tiles.filter(function (b) { return b.dataset.pick.toLowerCase() === pre.toLowerCase(); })[0];
if (match) pick(match, match.dataset.pick, match.dataset.code, match.dataset.img, true);
else pickName(pre, true);
var preAp = (new URLSearchParams(location.search).get('aeropuerto') || '').toUpperCase();
if (preAp && S.dest && S.dest.aps) {
var m = S.dest.aps.filter(function (a) { return String(a[0]).trim().toUpperCase() === preAp; })[0];
if (m) { setAp(m); renderAps(); }
}
} else {
go(1, true);
}
if ($('[data-has-errors]')) {
var lastTry = store(true);
if (lastTry && !S.dest) { S.dest = { name: lastTry.dest, code: lastTry.code, img: '' }; F('dest').value = lastTry.dest; }
go(3, true);
}
})();
